import React from 'react';
import classNames from 'classnames';
import { APPEARANCE } from './constants';
const FieldStatus = ({ appearance = APPEARANCE.default, text = '', ...otherProps }) => {
  const classes = classNames('ws-ui-field-status', `ws-ui-field-status--${appearance}`);

  return (
    <p className={classes} {...otherProps}>
      {text}
    </p>
  );
};

export default FieldStatus;
